import React, { FunctionComponent } from 'react';
import { useQuery } from 'react-apollo';
import { Container } from 'semantic-ui-react';
import withStyles from 'react-jss';
import { useParams } from 'react-router-dom';

import { ChartPlaceholder } from 'components/Placeholder';
import { ClassProp } from 'helpers/types';
import OffersTable from 'scenes/Home/components/OffersTable';
import {
  MatchParams,
  Offer,
} from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.types';
import { handleError } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.helpers';

import { GET_MERCHANT_OFFERS_RESULTS } from './MerchantOffers.queries';
import CreateCampaignModal from './scenes/CreateCampaignModal/CreateCampaignModal';
import CreateOfferModal from './scenes/CreateOfferModal/CreateOfferModal';

const styles = {
  container: {
    margin: '1.25rem auto !important',
    height: '100% !important',
  },
};

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
};

type QueryResponse = {
  offerFindBy: {
    offers: Offer[];
  };
};

const MerchantOffers: FunctionComponent<Props> = ({ classes }) => {
  const { merchantId, merchantName } = useParams<MatchParams>();
  const { data, loading } = useQuery<QueryResponse>(
    GET_MERCHANT_OFFERS_RESULTS,
    {
      variables: {
        params: { merchantUuid: merchantId },
      },
      onError: handleError,
      fetchPolicy: 'cache-first',
    },
  );

  return (
    <Container className={classes.container}>
      {loading ? (
        <ChartPlaceholder />
      ) : (
        <>
          <CreateCampaignModal />
          <CreateOfferModal merchant={{ merchantId, merchantName }} />
          <OffersTable data={data?.offerFindBy.offers || []} />
        </>
      )}
    </Container>
  );
};

export default withStyles(styles)(MerchantOffers);
